
import ProductInfoCard from "../ui/productInfoCard";
import BottomCart from "../ui/bottom-cart";
import { useLocation } from "react-router-dom";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { cartContext } from "../../App";
import HeaderOther from "../ui/header-other";
import './display-products-category.css';
import { getImageSourceFromGithub } from "../services/common-services";

export default function DisplayProductsCategory() {
    const { productDataList, maxAmountReached } = useContext(cartContext);
    const location = useLocation();
    const { category, name, categoryName, categoryData } = location.state || {};

    const hasCategoryData = categoryData && Array.isArray(categoryData.data) && categoryData.data.length > 0;

    const categoryItems = useMemo(() => {
        if (hasCategoryData) {
            return categoryData.data;
        }

        const cat = String(category || '')
            .split(',')
            .map((item) => item.trim())
            .filter(Boolean);
        const catName = String(categoryName || '')
            .split(',')
            .map((item) => item.trim());

        return cat.map((item, index) => ({
            id: item,
            name: catName[index] || item,
            data: [item],
        }));
    }, [category, categoryName, categoryData, hasCategoryData]);

    const [selected, setSelected] = useState(categoryItems[0]?.id || '');
    const [data, setData] = useState([]);
    const categoryScrollRef = useRef(null);
    const productScrollRef = useRef(null);

    useEffect(() => {
        if (!categoryItems.length) {
            setData([]);
            setSelected('');
            return;
        }

        const selectedItem = categoryItems.find((item) => item.id === selected) || categoryItems[0];
        if (selected !== selectedItem.id) {
            setSelected(selectedItem.id);
        }

        const filtered = productDataList.filter((item) => {
            const typeKey = String(item.data.productTypeId || '').trim();
            const categoryKey = String(item.data.category || '').trim();

            if (hasCategoryData) {
                return selectedItem.data.includes(typeKey);
            }

            return selectedItem.data.includes(typeKey) || selectedItem.data.includes(categoryKey);
        });

        setData(filtered);
    }, [productDataList, categoryItems, selected, hasCategoryData]);

    function changeCategory(productGroup, index) {
        setSelected(productGroup.id);

        const filteredData = productDataList.filter((item) => {
            const typeKey = String(item.data.productTypeId || '').trim();
            const categoryKey = String(item.data.category || '').trim();

            if (hasCategoryData) {
                return productGroup.data.includes(typeKey);
            }

            return productGroup.data.includes(typeKey) || productGroup.data.includes(categoryKey);
        });

        setData(filteredData);

        requestAnimationFrame(() => {
            productScrollRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
        });

        categoryScrollRef.current?.scrollTo({ top: index * 84, behavior: 'smooth' });
    }

    const hasProducts = data.length > 0;

    return (
        <>
            {maxAmountReached && (
                <div className="max-amount-reached">
                    <p className="max-amount-reached-text">Maximum Quantity Reached!</p>
                </div>
            )}

            <HeaderOther title={name || 'Products'} />

            <div className="display-products-category-box">
                <div className="category-left-column" ref={categoryScrollRef}>
                    {categoryItems.length ? (
                        categoryItems.map((productGroup, index) => {
                            const active = selected === productGroup.id;
                            return (
                                <div
                                    key={productGroup.id || index}
                                    className={`category-block ${active ? 'active' : ''}`}
                                    onClick={() => changeCategory(productGroup, index)}
                                >
                                    {active && <div className="indicator" />}
                                    <img
                                        src={getImageSourceFromGithub(`category-image/${productGroup.id}.png`).uri}
                                        className={`category-img ${active ? 'active-img' : ''}`}
                                        alt={productGroup.name}
                                    />
                                    <p className={`category-name ${active ? 'active-name' : ''}`}>
                                        {productGroup.name}
                                    </p>
                                </div>
                            );
                        })
                    ) : (
                        <div className="category-empty-message">No categories available.</div>
                    )}
                </div>

                <div className="products-panel" ref={productScrollRef}>
                    {hasProducts ? (
                        <ProductInfoCard dataList={data} />
                    ) : (
                        <div className="products-empty-message">
                            <p>No products found for this selection.</p>
                        </div>
                    )}
                </div>
            </div>

            <BottomCart />
        </>
    );
}



